import React from "react";
import { Building, ChevronDown, ChevronRight, Eye, EyeOff, Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { CardDescription, CardHeader, CardTitle } from "../ui/card";

const OrgTreeHeader = ({ showDetails, setShowDetails, expandAll, collapseAll, searchTerm, setSearchTerm }) => {
  const { t } = useTranslation();
  return (
  <CardHeader className="pb-3">
    <div className="flex items-center justify-between">
      <div>
        <CardTitle className="flex items-center space-x-2 text-lg">
          <Building className="h-5 w-5 text-primary" />
          <span>{t('org.title', 'Org Chart')}</span>
        </CardTitle>
        <CardDescription className="text-sm">{t('org.filterHint', 'Click a department to filter')}</CardDescription>
      </div>
      <div className="flex items-center space-x-1">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setShowDetails(!showDetails)}
          className="h-8 w-8"
          title={showDetails ? t("organigramme.tree.hideDetails") : t("organigramme.tree.showDetails")}
        >
          {showDetails ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </Button>
        <Button variant="ghost" size="icon" onClick={expandAll} className="h-8 w-8" title={t("organigramme.tree.expandAll")}>
          <ChevronDown className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" onClick={collapseAll} className="h-8 w-8" title={t("organigramme.tree.collapseAll")}>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
    <div className="relative mt-3">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder={t('org.searchDepartment', 'Search department...')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10 pr-10 h-9 bg-muted/30 border-muted focus:bg-background"
      />
      {searchTerm && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setSearchTerm("")}
          className="absolute right-1 top-1/2 transform -translate-y-1/2 h-7 w-7"
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  </CardHeader>
  );
};

export default OrgTreeHeader;
